<template>
    <modal
        name="shown-after-demo-watched"
        width="100%"
        :maxWidth="1200"
        height="auto"
        :adaptive="true"
        :scrollable="true"
    >
        <div class="course-video-modal">
            <h1 class="course-video-modal__title" v-if="!isLoggedIn" v-html="$t('ModalAfterDemo.log_in_to_keep_watching')"></h1>
            <h1 class="course-video-modal__title" v-else v-html="$t('ModalAfterDemo.you_cannot_access')"></h1>
            <LoginSSO :noBorders=true v-if="!isLoggedIn"/>
            <h1 class="course-video-modal__title -cta" v-if="!isLoggedIn" v-html="$t('ModalAfterDemo.like_to_hear_more')"></h1>
            <div class="modal-cta-box">
                <TotemCtaButton
                    v-if="isLoggedIn"
                    :url="$t('Button.contact_us_url')"
                    :label="$t('Button.contact_us')"
                    class="modal-cta-box__button"
                />
                <TotemCtaButton
                    v-else
                    class="modal-cta-box__button"
                    url="trial"
                    :label="$t('ModalAfterDemo.subscribe_demo')"
                />
                <h1 class="course-video-modal__title -cta" v-if="isLoggedIn" v-html="$t('ModalAfterDemo.like_to_stay')"></h1>
                <TotemButton @click="refreshPage" class="modal-cta-box__button" v-if="!isLoggedIn" :label="$t('ModalAfterDemo.keep_not_loggin_in')" />
                <TotemButton @click="refreshPage" class="modal-cta-box__button" :label="$t('ModalAfterDemo.stay_on_page')" v-else />
            </div>
        </div>
    </modal>
</template>

<script>
    import LoginSSO from 'components/user/LoginSSO'
    import { mapGetters } from 'vuex'

    export default {
        name: 'ModalShownAfterDemoWatched',
        components: {
            LoginSSO
        },
        props: {
            isDemo: Boolean
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn'
            }),
            userHasAccess () {
                return this.isLoggedIn && !this.isDemo
            }
        },
        methods: {
            refreshPage () {
                location.reload()
            }
        },
        watch: {
            userHasAccess: {
                handler (hasAccess) {
                    if (hasAccess) {
                        this.$modal.hide('shown-after-demo-watched')
                    }
                },
                immediate: true
            }
        },
    }
</script>

<style lang="scss" scoped>
    .course-video-modal {
        padding: 20px;
        width: 100%;

        [class*="desktop"] & {
            padding: 70px;
        }

        &__title {
            text-align: center;
            font-size: 2.2rem;
            margin: 0 0 20px;

            &.-cta {
                padding-top: 30px;
            }

            [class*="desktop"] & {
                font-size: 2.8rem;
            }
        }
    }

    .modal-cta-box {
        display: flex;
        flex-direction: column;
        margin: 0 auto;

        &__button {
            align-self: center;
            margin: 30px 0 0 0;
        }
    }
</style>
